(function () {

    'use strict';

    if (typeof window === 'undefined') {

        socialPosts(
            module.exports,
            require('../../metric/metric.js'),
            require('./base.js'),
            require('./dimensions.js'),
            require('./aggregates.js'),
            require('./expansions.js'),
            require('../../utils/timePeriod.js'),
            require('../../../../lib/riq-moment.js'),
            require('../../../enums/metrics.js'),
            require('lodash'),
            require('underscore.string')
        );

    } else {

        socialPosts(
            RivalIQ.models.metrics,
            RivalIQ.metric,
            RivalIQ.models.metrics,
            RivalIQ.models.metrics,
            RivalIQ.models.metrics,
            RivalIQ.models.metrics.expansions,
            RivalIQ.utils.timePeriod,
            window.moment,
            RivalIQ.enums,
            window._,
            window.s
        );
    }

    function socialPosts(metrics, metricFn, base, dimensions, aggregates, expansions, timePeriodUtils, moment, metricEnums, _, s) {

        function getCollections() {
            return (typeof window === 'undefined' ? require('../../collections/metrics.js') : RivalIQ.collections);
        }

        function getModels() {
            return (typeof window === 'undefined' ? require('../metric.js') : RivalIQ.models);
        }

        function getSocialPostModels() {
            return (typeof window === 'undefined' ? require('../../../../public/modules/models/post.js') : RivalIQ.models);
        }

        const socialPostsMixin = {
            build: function (attrs, options) {
                const me = this;

                const metricAttributes = metricFn.build(me.attributes, attrs, options);
                metricAttributes.returns = attrs.returns || metricAttributes.property;

                const expanded = expansions.expandDefinition(metricAttributes, me);
                const properties = (expanded ? expanded : metricAttributes);
                const models = getModels();

                let definition;
                if (me.get('concept')) {
                    definition = new models.MetricDefinition(me.get('concept'), properties);
                } else {
                    definition = new models.MetricDefinition(properties);
                }

                if (expanded) {
                    definition.unexpandedAttributes = metricAttributes;
                }

                return definition;
            },

            getDataTimePeriod: function () {
                const me = this;

                const startDate = me.get('startDate');
                if (startDate) {
                    return timePeriodUtils.rehydrate({
                        mainPeriodStart: startDate,
                        mainPeriodEnd: me.get('endDate')
                    });
                }

                return RivalIQ.state.view.get('timePeriod');
            },

            getValue: function (options) {
                const me = this;
                options = _.defaults(options || {}, {
                    format: true
                });

                if (_.exists(me.attributes.value)) {
                    return (_.isFunction(me.attributes.value) ? me.attributes.value.call(me, options) : me.attributes.value);
                }

                function aggregate(submetric, method) {
                    if (!submetric) {
                        return undefined;
                    }

                    if (me.attributes.property === 'name') {
                        return me.getName();
                    }

                    if (submetric[method]) {
                        return submetric[method];
                    }

                    const value = aggregates.aggregate(me, submetric, method, me.over);
                    return me._formatValue(value, options);
                }

                function value(submetric, name) {
                    let val;
                    const property = (_.isUndefined(me.get('property')) ? 'count' : me.get('property'));

                    const result = me.getSubmetricValue(property, submetric);
                    if (!_.isUndefined(result)) {
                        return result;
                    }

                    if (property === 'name') {
                        val = name;
                    } else if (!submetric) {
                        val = undefined;
                    } else {
                        val = metrics.evaluateExpression(submetric, property, me);
                    }

                    return me._formatValue(val, options);
                }

                function extract(submetric, dimensions, name) {
                    if (_.isEmpty(dimensions)) {

                        if (me.attributes.aggregate) {
                            return aggregate(submetric, me.attributes.aggregate);
                        }

                        return value(submetric, name);
                    }

                    const dimension = _.head(dimensions);

                    if (!submetric.dimensions || !submetric.dimensions[dimension]) {
                        return [];
                    }

                    _.each(submetric.dimensions[dimension].buckets, function (bucket) {
                        bucket._parent = submetric;
                    });

                    submetric = submetric.dimensions[dimension].buckets;

                    if (!_.isUndefined(me.attributes[dimension])) {
                        let subresult;

                        if (submetric) {
                            subresult = extract(submetric[me.attributes[dimension]], _.without(dimensions, dimension), dimension);
                        } else { // Bucket does not have the specified dimension
                            subresult = null;
                        }

                        if (!_.isArray(subresult)) {
                            return subresult;
                        }

                        return _.map(subresult, function (r) {
                            return [undefined].concat(r);
                        });
                    }

                    return _.reduce(submetric, function (result, values, dimensionValue) {
                        const subresult = extract(values, _.without(dimensions, dimension), dimensionValue);

                        if (_.isArray(subresult)) {
                            _.forEach(subresult, function (arr) {
                                arr.unshift(dimensionValue);
                            });

                            return result.concat(subresult);
                        }

                        const transformedDimensionValue = me.transformDimensionValue(dimension, dimensionValue);

                        result.push([transformedDimensionValue].concat(subresult));
                        return result;
                    }, []);
                }

                const data = me.data;

                function getDataDimensionOrder(metric, dimensions) {
                    if (!dimensions.length) {
                        return [];
                    }

                    return _.reduce(dimensions, function (memo, dimension) {

                        if (memo) {
                            return memo;
                        }

                        const buckets = _.get(metric, ['dimensions', dimension, 'buckets']);

                        // If there is only one dimension we already know the correct
                        // order
                        if (dimensions.length === 1 && buckets) {
                            return [dimension];
                        } else if (_.size(buckets)) {
                            const bucket = (_.isUndefined(me.get(dimension)) ? _.head(_.values(buckets)) : buckets[me.get(dimension)]);
                            const sub = getDataDimensionOrder(bucket, _.without(dimensions, dimension));
                            return (sub ? [dimension].concat(sub) : false);
                        }

                        return false;
                    }, false);
                }

                const dimensions = me.getDimensions();
                const orderedDimensions = getDataDimensionOrder(data, dimensions);

                if (!orderedDimensions) {
                    return [];
                }

                const values = extract(data, orderedDimensions);

                // Reorder results array to match dimensions array order
                const order = _.map(metricFn.getFreeDimensions(me.attributes), function (dimension) {
                    return _.indexOf(orderedDimensions, dimension);
                });

                // NOTE if we have an `order`, and `values` is an array then we
                // need to reorder the results, otherwise we are dealing with a
                // single value (like a string, that will not be mapped in the
                // way that we expect, see #17352)
                if (order.length && _.isArray(values)) {
                    return _.map(values, function (valueArray) {
                        const reordered = _.map(order, function (idx) {
                            return (_.isNull(idx) ? undefined : valueArray[idx]);
                        });

                        return _.compact(reordered).concat(_.last(valueArray));
                    });
                }

                return values;
            },
            getDimensions: function () {
                const me = this;
                return me.attributes.dimensions || [];
            },
            // Serialize metric with all relevant options so that export can
            // recreate the state
            serialize: function () {
                const me = this;
                const queryAttrs = RivalIQ.apps.SocialPosts.utils.validQueryParams.concat('includePostTagColumns');
                const json = _.extend({
                    concept: me.get('concept')
                }, me.toType(), _.pick(me.attributes, queryAttrs));

                delete json.postIds;

                _.defaults(json, _.pick(RivalIQ.state.view.attributes, queryAttrs));
                _.defaults(json, {
                    landscapeId: RivalIQ.state.view.get('landscapeId'),
                    companySetDescriptor: RivalIQ.state.view.get('companySetDescriptor'),
                    startDate: moment.utc(RivalIQ.state.view.get('timePeriod').mainPeriodStart).startOf('day').toJSON(),
                    endDate: moment.utc(RivalIQ.state.view.get('timePeriod').mainPeriodEnd).endOf('day').toJSON()
                });

                return json;
            },

            // NOTE we return the whole obj here because property name is not
            // necessarily enough data to know what to sort on
            getOrderBy: function () {
                const me = this;
                return me.serialize();
            },

            getName: function (options) {
                const me = this;
                options = options || {};

                const override = me.byOverride('name');
                if (override) {
                    return override;
                }

                const name = dimensions.getProperty(me, 'name');

                if (me.get('aggregate')) {
                    return me.byAggregate('name', name);
                }

                return name;
            },

            transformDimensionValue: function (dimension, dimensionValue) {
                return dimensionValue;
            }
        };

        /*
         * VERY BASIC ltr expression evaluation
         */
        metrics.evaluateExpression = function (submetric, expression, metric) {
            const tokens = expression.split(/\s+/);

            do {
                const value = applyOp(metric, submetric, tokens[0], tokens[2], tokens[1]);
                tokens.splice(0, 3, value);
            } while (tokens[1]);

            return tokens[0];
        };

        function getPropertyValue(metric, data, property) {
            // NOTE property can be `undefined` if this is an expression with
            // several operations (e.g., `a / b / c`) where one previous
            // operation yields `undefined` (specifically for division)
            if (_.isUndefined(property)) {
                return property;
            }

            if (!_.isNaN(Number(property))) {
                return Number(property);
            }

            let value;
            if (property.indexOf('.') !== -1) {
                const path = property.split('.');
                value = getDimensionDataValue(data, path[0], path[1]);
                return (_.isUndefined(value) ? _.get(metric.data, path, metric.get('default')) : value);
            }

            value = expansions.expandPropertyValue(metric, data, property);
            return (_.isUndefined(value) ? metric && metric.get('default') : value);
        }

        function applyOp(metric, data, left, right, operator) {
            if (!operator) {
                return getPropertyValue(metric, data, left);
            }

            const timeAnalysisMode = _.get(metric, ['attributes', 'timeAnalysisMode']);
            if (timeAnalysisMode && !_.includes([metricEnums.timeAnalysisMode.MAIN_PERIOD, metricEnums.timeAnalysisMode.COMPARE_PERIOD], timeAnalysisMode)) {
                RivalIQ.logger.error(`Invalid Metric -- cannot calculate delta metrics for an expression metric: ${JSON.stringify(metric.attributes)}`);
            }

            const leftValue = getPropertyValue(metric, data, left);
            const rightValue = getPropertyValue(metric, data, right);

            switch (operator) {
                case '-':
                    return leftValue - rightValue;
                case '+':
                    return leftValue + rightValue;
                case '*':
                    return leftValue * rightValue;
                case '/': {
                    if (_.isNull(leftValue)) {
                        return null;
                    }
                    const value = leftValue / rightValue;
                    return (!_.isFinite(value) ? undefined : value);
                }
                default:
                    throw new Error(`unknown operator ${operator}`);
            }
        }

        function getDimensionDataValue(submetric, dimension, property) {
            let dimensionData;

            do {
                dimensionData = _.get(submetric, ['dimensions', dimension]);
                submetric = submetric._parent;
            } while (!dimensionData && submetric);

            if (!dimensionData) {
                return undefined;
            }

            const val = dimensionData[property];

            if (_.isUndefined(val) && property === 'count') {
                return _.size(dimensionData.buckets);
            }

            return val;
        }

        const metricBase = metrics._metricBase = _.extend({}, base.baseMixin, socialPostsMixin);
        metrics.getMetricBase = function () {
            return metrics._metricBase;
        };

        function shouldCallNewMetrics(attrs) {
            return _.includes(['SOCIAL_POST', 'SOCIAL_POSTS', 'SOCIAL_POSTS_HASHTAGS', 'SOCIAL_POSTS_POST_TAG_IDS'], attrs.key) &&
                !attrs.withObservations &&
                // See #33802 - the new post metrics needs to support ranges for at least engagement_total and engagement_rate.
                _.isEmpty(attrs.metricValues);
        }

        metrics.SocialPost = _.extend({}, metricBase, {
            build: function (attrs, options) {
                const me = this;
                const definition = metricBase.build.call(me, attrs, options);
                definition.data = me.data;
                definition.companyData = me.companyData;
                return definition;
            },

            getSubmetricValue: function (property, submetric) {
                const me = this;
                const socialPostModels = getSocialPostModels();

                if (property === 'post') {
                    return new socialPostModels.Post(submetric, {
                        companyData: me.companyData
                    });
                }
            },

            fetch: function (attrs) {
                const me = this;

                let deferred;
                if (me.data && me.companyData) {
                    deferred = new $.Deferred();
                    deferred.resolve(me.data);
                } else {
                    attrs = _.extend(me.resolvedAttributes(), attrs);

                    if (shouldCallNewMetrics(attrs)) {
                        deferred = RivalIQ.metrics.new.client.MetricConverter.fetchPosts(me, attrs);
                    } else {
                        deferred = RivalIQ.apps.SocialPosts.data.socialPosts.fetch(attrs);
                    }
                }

                return deferred.then(function (data) {
                    const attributes = me.resolvedAttributes();
                    const models = getModels();

                    if (attributes.submetrics) {
                        const collections = getCollections();
                        attributes.submetrics = new collections.Metrics(attributes.submetrics.map(function (sub) {
                            return new models.Metric(_.extend({
                                concept: sub.concept
                            }, sub.attributes), data);
                        }));
                    }

                    const metric = new models.Metric(attributes, data);
                    metric.companyData = RivalIQ.state.landscape.get('companies');
                    metric.unexpandedAttributes = me.unexpandedAttributes;

                    return metric;
                });
            },

            getDimensions: function () {
                const me = this;
                return _.without(me.attributes.dimensions, 'timeAnalysisMode', 'channel') || [];
            }
        });

        const SocialPostMetric = {
            fetch: function (attrs) {
                const me = this;

                attrs = _.extend({}, attrs, me.resolvedAttributes());

                let deferred;
                if (shouldCallNewMetrics(attrs)) {
                    deferred = RivalIQ.metrics.new.client.MetricConverter.fetchPostAggregates(me, attrs);
                } else {
                    deferred = _.result(me, 'metricsCollection').fetch(attrs);
                }

                return deferred
                    .then(function (data) {
                        const attributes = me.resolvedAttributes();
                        const models = getModels();

                        if (attributes.submetrics) {
                            const collections = getCollections();
                            attributes.submetrics = new collections.Metrics(attributes.submetrics.map(function (sub) {
                                return new models.Metric(_.extend({
                                    concept: sub.concept
                                }, sub.attributes), data);
                            }));
                        }

                        const metric = new models.Metric(attributes, data);
                        metric.unexpandedAttributes = me.unexpandedAttributes;
                        return metric;
                    });
            }
        };

        metrics.PostedUrls = _.defaults({
            dataSource: 'elasticsearch',

            metricsCollection: function () {
                return RivalIQ.apps.SocialPosts.data.postedUrls;
            },

            getSubmetricValue: function (property, submetric) {
                if (property === 'observation') {
                    return submetric;
                }
            }
        }, metricBase, SocialPostMetric);


        const socialPostMetrics = [
            'socialPosts',
            'hashtags',
            'postTagIds'
        ];

        _.reduce(socialPostMetrics, function (memo, socialPostMetric) {
            const Metric = _.extend({}, metricBase, SocialPostMetric, {
                dataSource: 'elasticsearch',
                metricsCollection: function () {
                    return RivalIQ.apps.SocialPosts.data[socialPostMetric];
                }
            });

            return _.set(memo, s.capitalize(socialPostMetric), Metric);
        }, metrics);

    }

})();
